<template>
	<div>
		<!--列表-->
		<el-table size="small" :data="listData" border>
			<el-table-column prop="deptId" label="任务编号" align="center">
			</el-table-column>
			<el-table-column prop="deptId" label="图片" align="center">
				<template slot scope="scope">
					<el-image class="main-img" fit="contain" :src="imgh+'stuwork_' + scope.row.deptId + '_m_0.png'"
						alt="" />
				</template>
			</el-table-column>
			<el-table-column prop="deptName" label="任务名" align="center">
			</el-table-column>
			<el-table-column prop="wtypes" label="类型" align="center">
				<template slot scope="scope">
					<div>{{wtypes[scope.row.wtypes]}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="numtype" label="报名设置" align="center">
				<template slot scope="scope">
					<div>{{numtype[scope.row.numtype]}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="price" label="价格" align="center">
			</el-table-column>
			<el-table-column prop="ynum" label="已报名/通过审核" align="center">
				<template slot scope="scope">
					<div class="new-user" v-if="scope.row.ynum[0][1]>0">+{{scope.row.ynum[0][1]}}</div>
					<div class="user-name">{{scope.row.ynum[0][0]}}/{{scope.row.ynum[1]}}</div>
					<el-button size="small" type="primary" @click="handleEdit(scope.$index,0)" plain>查看报名</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="state" label="二维码" align="center">
				<template slot scope="scope">
					<el-image class="main-img" fit="contain" :src="fimgh+'stuWorkqr_' + scope.row.deptId + '.png'"
						alt="" />
					<div>{{state[scope.row.state]}}</div>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog :title="title" width="1000px" :visible.sync="editFormVisible" @click='closeDialog("edit")'>
			<div class="info-block">
				<div class="info-block-l">
					<div class="info-title">{{editForm.deptName}}</div>
					<div class="info-des">{{editForm.des}}</div>
					<div class="info-de">
						<div>联系人：{{editForm.phone}}</div>
						<div>{{wtypes[editForm.wtypes]}} | {{numtype[editForm.numtype]}}</div>
						<div v-if="editForm.skill.length">
							<el-tag size="small" style="margin-right: 5px;" v-for="chmenu in editForm.skill"
								type="success">{{chmenu}}</el-tag>
						</div>
					</div>
					<div class="info-img">
						<div class="info-img-l">
							<el-carousel trigger="click" height="200px">
								<el-carousel-item v-for="item in editForm.zimg">
									<el-image style="height: 200px;" class="main-img" fit="scale-down"
										:src="item.url" />
								</el-carousel-item>
							</el-carousel>
						</div>
						<div>
							<el-carousel height="200px">
								<el-carousel-item v-for="item in editForm.ximg">
									<el-image style="height: 200px;" class="main-img" fit="scale-down"
										:src="item.url" />
								</el-carousel-item>
							</el-carousel>
						</div>
					</div>
				</div>
				<div class="info-block-r">
					<el-tabs :stretch="true" v-model="activeName" @tab-click="handleClick">
						<el-tab-pane label="报名学生" name="0">
							<div v-if="baoming.length" class="stu-list">
								<div class="stu-list-block" v-for="(item,index ) in baoming">
									<div class="stu-top">
										<div>{{item.name}}</div>
										<div>{{item.phone}}</div>
									</div>
									<div class="stu-media">
										<div class="stu-media-l">{{item.ages}}岁 {{item.gender?'男':'女'}}</div>
										<div class="stu-media-r" v-if="item.positone">{{item.positone}}</div>
										<div v-else class="stu-bottom">
											<el-button class="stu-bottom-button" size="mini" type="success"
												@click="refuseTheStu(index,0)" plain>婉拒</el-button>
											<el-button class="stu-bottom-button" size="mini" type="primary"
												@click="refuseTheStu(index,1)" plain>选中</el-button>
										</div>
									</div>
									<div class="stu-media1">
										{{item.major}}
									</div>
									<div class="stu-media1">
										{{item.school}}
									</div>
									<div v-if="item.ch">
										<div class="stu-list-blocks" v-for="(ite,inde ) in item.ch">
											<div class="stu-top">
												<div>{{ite.name}}</div>
												<div>{{ite.phone}}</div>
											</div>
											<div class="stu-media">
												<div class="stu-media-l">{{ite.ages}}岁 {{ite.gender?'男':'女'}}</div>
												<div class="stu-media-r" v-if="ite.positone">{{ite.positone}}</div>
											</div>
											<div class="stu-media1">
												{{ite.major}}
											</div>
											<div class="stu-media1">
												{{ite.school}}
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="no-list-block" v-else>
								暂未有学生报名
							</div>
						</el-tab-pane>
						<el-tab-pane label="通过审核" name="1">
							<div v-if="baoming.length" class="stu-list">
								<div class="stu-list-block" v-for="(item,index ) in baominged">
									<div class="stu-top">
										<div>{{item.name}}</div>
										<div>{{item.phone}}</div>
									</div>
									<div class="stu-media">
										<div class="stu-media-l">{{item.ages}}岁 {{item.gender?'男':'女'}}</div>
										<div class="stu-media-r" v-if="item.positone">{{item.positone}}</div>
									</div>
									<div class="stu-media1">
										{{item.major}}
									</div>
									<div class="stu-media1">
										{{item.school}}
									</div>
									<div v-if="item.ch">
										<div class="stu-list-blocks" v-for="(ite,inde ) in item.ch">
											<div class="stu-top">
												<div>{{ite.name}}</div>
												<div>{{ite.phone}}</div>
											</div>
											<div class="stu-media">
												<div class="stu-media-l">{{ite.ages}}岁 {{ite.gender?'男':'女'}}</div>
												<div class="stu-media-r" v-if="ite.positone">{{ite.positone}}</div>
											</div>
											<div class="stu-media1">
												{{ite.major}}
											</div>
											<div class="stu-media1">
												{{ite.school}}
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="no-list-block" v-else>
								暂无通过审核的学生
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
			<div class="dialog-footer">
				<el-button v-if="listData[theindex].state == 1 && listData[theindex].ynum[1] == 0" size="small"
					@click='offTheWork()' type="danger">下线</el-button>
				<el-button v-if="listData[theindex].state == 2 && listData[theindex].ynum[1]>0" size="small"
					type="primary" class="title" @click="saveTheWork()">开工</el-button>
			</div>
		</el-dialog>
	</div>

</template>
<script>
	import {
		GetTheRecruiting,
		StartingAndOffline,
		GetTheWorkInfoToBegin,
		RefuseTheStu,
		calculateAge,
		PictureServer
	} from '../../api/userMG'
	export default {
		data() {
			return {
				theindex: 0,
				listData: [],
				cInfo: JSON.parse(localStorage.getItem('userInfo')),
				numtype: ['仅限个人', '仅限团队', '不限'],
				wtypes: ['', '长期任务', '短期任务', '设计项目', '线下实习'],
				state: ['未上线', '暂无报名', '已有报名', '工作中', '结束', '停止'],
				editFormVisible: false,
				editForm: {
					deptName: '',
					numtype: '',
					wtypes: '',
					price: '',
					phone: '',
					skill: '',
					des: '',
					urls: '',
					zimg: [],
					ximg: []
				},
				getBmed: false,
				activeName: 0,
				baoming: [],
				baominged: [],
				shenghe: [],
				imgh: PictureServer.Info,
				fimgh: PictureServer.Forum
			}
		},
		created() {
			GetTheRecruiting(1).then(res => {
				var goodss = [],
					ynum
				for (var j = 0; j < res.length; j++) {
					ynum = res[j][5].split("]")
					ynum[0] = ynum[0].split(',')
					goodss.push({
						ynum: ynum,
						deptName: res[j][1],
						deptId: res[j][0],
						price: res[j][3],
						wtypes: res[j][2],
						numtype: res[j][4],
						state: res[j][6]
					})
				}
				this.listData = goodss
			})
		},
		methods: {
			//添加或编辑工作
			handleEdit: function(index, t) {
				this.theindex = index
				this.editFormVisible = true
				this.title = '报名详情'
				GetTheWorkInfoToBegin(this.listData[index].deptId, 0).then(res => {
					this.editForm.deptName = this.listData[index].deptName
					this.editForm.numtype = this.listData[index].numtype
					this.editForm.wtypes = this.listData[index].wtypes
					this.editForm.price = this.listData[index].price
					this.editForm.phone = res.i[3]
					this.editForm.des = res.i[0]
					this.editForm.skill = res.i[1] ? res.i[1].split(" ") : []
					this.editForm.zimg = []
					this.activeName = "0"
					this.editForm.ximg = []
					this.baoming = []
					//不同报名形式对应不同的数组
					if (res.s) {
						res.s.forEach(e => {
							for (var i = 0; i < res.si.length; i++) {
								if (e[1] == res.si[i][0]) {
									if (e[2] == 0) {
										this.baoming.push({
											wiid: e[0],
											uid: e[1],
											name: res.si[i][1],
											ages: calculateAge(res.si[i][2]),
											gender: res.si[i][3],
											phone: res.si[i][4],
											school: res.si[i][5],
											major: res.si[i][6],
											auth: res.si[i][7],
											upid: e[2],
											ch: []
										})
									} else if (e[2] == null) {
										this.baoming.push({
											wiid: e[0],
											uid: e[1],
											name: res.si[i][1],
											ages: calculateAge(res.si[i][2]),
											gender: res.si[i][3],
											phone: res.si[i][4],
											school: res.si[i][5],
											major: res.si[i][6],
											auth: res.si[i][7],
											upid: e[2]
										})
									} else {
										for (var j = 0; j < this.baoming.length; j++) {
											if (this.baoming[j].wiid == e[2]) {
												this.baoming[j].ch.push({
													wiid: e[0],
													uid: e[1],
													name: res.si[i][1],
													ages: calculateAge(res.si[i][2]),
													gender: res.si[i][3],
													phone: res.si[i][4],
													school: res.si[i][5],
													major: res.si[i][6],
													auth: res.si[i][7],
													positone: e[3]
												})
												break
											}
										}
									}
									break
								}
							}
						})
					}
					if (res.i[2]) {
						var imgss = res.i[2].split(",")
						for (var k = 0; k < imgss[0]; k++) {
							this.editForm.zimg.push({
								url: PictureServer.Info + 'stuwork_' + this.listData[index]
									.deptId + '_m_' + k +
									'.png'
							})
						}
						for (var k = 0; k < imgss[1]; k++) {
							this.editForm.ximg.push({
								url: PictureServer.Info + 'stuwork_' + this.listData[index]
									.deptId + '_d_' + k +
									'.png'
							})
						}
					}
				})

			},
			// 关闭编辑、增加弹出框
			closeDialog() {
				this.editFormVisible = false
				this.getBmed = false
			},
			handleClick(tab, event) {
				if (this.activeName == 1 && this.getBmed == false) {
					GetTheWorkInfoToBegin(this.listData[this.theindex].deptId, 1).then(res => {
						this.editForm.deptName = this.listData[this.theindex].deptName
						this.editForm.numtype = this.listData[this.theindex].numtype
						this.editForm.wtypes = this.listData[this.theindex].wtypes
						this.editForm.price = this.listData[this.theindex].price
						this.editForm.phone = res.i[3]
						this.editForm.des = res.i[0]
						this.editForm.skill = res.i[1] ? res.i[1].split(" ") : []
						this.editForm.zimg = []
						this.activeName = "1"
						this.editForm.ximg = []
						this.baominged = []
						this.getBmed = true
						//不同报名形式对应不同的数组
						if (res.s) {
							res.s.forEach(e => {
								for (var i = 0; i < res.si.length; i++) {
									if (e[1] == res.si[i][0]) {
										if (e[2] == 0) {
											this.baominged.push({
												wiid: e[0],
												uid: e[1],
												name: res.si[i][1],
												ages: calculateAge(res.si[i][2]),
												gender: res.si[i][3],
												phone: res.si[i][4],
												school: res.si[i][5],
												major: res.si[i][6],
												auth: res.si[i][7],
												upid: e[2],
												positone: e[3],
												ch: []
											})
										} else if (e[2] == null) {
											this.baominged.push({
												wiid: e[0],
												uid: e[1],
												name: res.si[i][1],
												ages: calculateAge(res.si[i][2]),
												gender: res.si[i][3],
												phone: res.si[i][4],
												school: res.si[i][5],
												major: res.si[i][6],
												auth: res.si[i][7],
												upid: e[2]
											})
										} else {
											for (var j = 0; j < this.baominged.length; j++) {
												if (this.baominged[j].wiid == e[2]) {
													this.baominged[j].ch.push({
														wiid: e[0],
														uid: e[1],
														name: res.si[i][1],
														ages: calculateAge(res.si[i][2]),
														gender: res.si[i][3],
														phone: res.si[i][4],
														school: res.si[i][5],
														major: res.si[i][6],
														auth: res.si[i][7],
														positone: e[3]
													})
													break
												}
											}
										}
										break
									}
								}
							})
						}
						if (res.i[2]) {
							var imgss = res.i[2].split(",")
							for (var k = 0; k < imgss[0]; k++) {
								this.editForm.zimg.push({
									url: PictureServer.Info + 'stuwork_' + this.listData[this.theindex]
										.deptId + '_m_' + k +
										'.png'
								})
							}
							for (var k = 0; k < imgss[1]; k++) {
								this.editForm.ximg.push({
									url: PictureServer.Info + 'stuwork_' + this.listData[this.theindex]
										.deptId + '_d_' + k +
										'.png'
								})
							}

						}
					})
				}
			},
			refuseTheStu(index, t) {
				if (t == 1) {
					var con = '准许此' + (this.baoming[index].upid == 0 ? '团队' : '同学') + '报名？确认后将无法撤销和删除，请谨慎确认！'
				} else {
					var con = '拒绝此' + (this.baoming[index].upid == 0 ? '团队' : '同学') + '？提交后其将无法再报名，请确认！'
				}
				this.$confirm(con, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (t == 1) {
						this.listData[this.theindex].ynum[0][0]--
						this.listData[this.theindex].ynum[1]++
						this.listData[this.theindex].state = 2
					} else {
						this.listData[this.theindex].ynum[0][0]--
					}
					RefuseTheStu(this.baoming[index].wiid, t, this.listData[this.theindex].deptId, this.listData[
							this.theindex].ynum[0][0] +
						',0]' + this.listData[this.theindex].ynum[1]).then(res => {
						if (res) {
							if (t == 1) {
								this.baominged.unshift(this.baoming.splice(index, 1)[0])
							} else {
								this.baoming.splice(index, 1)
							}
							this.$message.success('操作成功')
						}
					})
				})
			},
			saveTheWork() {
				this.$confirm('确定开始工作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.editFormVisible = false
					StartingAndOffline(this.listData[this.theindex].deptId, 1).then(res => {
						if (res) {
							this.listData.splice(this.theindex, 1)
							this.$message.success('工作已开始！')
							this.getBmed = false
						}
					})
				})
			},
			offTheWork() {
				this.$confirm('确定将该工作下线?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.editFormVisible = false
					StartingAndOffline(this.listData[this.theindex].deptId, 0).then(res => {
						if (res) {

							this.listData.splice(this.theindex, 1)
							this.$message.success('工作已下线！')
							this.getBmed = false
						}
					})
				})
			}
		}
	}
</script>

<style scoped>
	.new-user {
		position: absolute;
		top: 5px;
		right: 5px;
		font-size: 16px;
		font-weight: bold;
		color: #07c160;
	}

	.user-name {
		font-size: 18px;
		margin-bottom: 10px;
	}

	.dialog-footer {
		position: absolute;
		top: 25px;
		right: 20%;
	}


	.main-img {
		width: 100%;
	}


	.info-block {
		width: 100%;
		display: flex;
	}

	.info-block-l {
		width: 70%;
		background: #fff;
	}

	.info-title {
		font-size: 20px;
	}

	.info-des {
		padding: 8px 10px 10px 0;
		white-space: pre-line;
	}

	.info-de div {
		margin-bottom: 5px;
	}

	.info-img {
		width: 100%;
	}

	.info-img-l {
		width: 50%;
		float: left;
	}

	.info-block-r {
		width: 30%;
		height: 500px;
		overflow: auto;
	}

	.stu-list {
		background: #f3f3f3;
	}

	.stu-list-block {
		background: #fff;
		margin: 5px 0;
		padding: 8px;
		border-bottom-color: #ff0000;
	}
	.no-list-block {
		margin: 60px 0;
		width: 100%;
		text-align: center;
		font-size: 17px;
	}
	.stu-top {
		width: 100%;
		display: inline-block;
	}

	.stu-top :first-child {
		float: left;
		font-size: 18px;
		font-weight: bold;
	}

	.stu-top :last-child {
		float: right;
	}

	.stu-media {
		width: 100%;
		display: inline-block;
	}

	.stu-media-l {
		float: left;
	}

	.stu-media-r {
		float: right;
		font-size: 15px;
		font-weight: bold;
	}

	.stu-bottom {
		float: right;
	}

	.stu-bottom-button {
		margin-left: 20px;
	}

	.stu-media1 {
		padding-top: 3px;
		font-size: 12px;
	}


	.stu-list-blocks {
		background: #fff;
		margin-top: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/views/school/recruiting.vue